import { Action, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';
import { IProfileStatusState } from './models/profile-status.model';
import { IBankProofDocumentsState } from './models/bank-proof-documents.model';

import {
  fromSendTaxReducerReducer,
  fromTaxYearsReducer,
  fromToDoReducer,
  fromPrivacySettingsReducer,
  fromHomeAddressReducer,
  fromRejectReducer,
  fromALIVEReducer,
  fromUnBLockReducer,
  fromUnLockReducer,
  fromApproveReducer,
  fromPreviousSelfieReducer,
  fromSelfieReducer,
  fromGovIdReducer,
  fromUserRoleReducer,
  fromCheckRemoveReducer,
  fromRemoveReducer,
  fromLockReducer,
  fromGenerateOtpReducer,
  fromCheckLockReducer,
  fromCheckBlockReducer,
  fromBlockReducer,
  fromUpdateDeceasedReducer,
  fromDeceasedReducer,
  fromEmployeeDetailReducer,
  fromGovIdProofReducer,
  fromOpenFileReducer,
  fromRetirementPlanReducer,
  fromFNA,
  fromStatements,
  fromTransactionsAll,
  fromFilteredTransactions,
  fromPreviousStatements,
  botflowPlaybackReducer,
  fromBankProofDocumentsReducer,
  fromApproveBankProofDocumentReducer,
  fromRejectBankProofDocumentReducer,
  fromArchivedBankProofDocumentsReducer,
  fromAddBankReducer,
  fromUpdateMemberDetailReducer,
  fromComplianceReducer,
  fromAddTrustBeneficiaryReducer,
  fromAddIndividualBeneficiaryReducer,
  fromAddCharityBeneficiaryReducer,
  fromEmployeeGovtIdDetailsReducer,
  fromEmployeeHomeAddressReducer
} from '../employee-detail/reducers';
import * as fromCurrentProducts from './reducers/current-products.reducer';
import * as fromArchivedProducts from './reducers/archived-products.reducer';
import * as fromNotifications from './reducers/notifications.reducer';
import * as fromBiDetails from './reducers/bi-details.reducer';
import * as fromBiRemoveDetails from './reducers/bi-remove-employee.reducer';
import * as fromBiUpdateBusinessDetails from './reducers/bi-update-business-details.reducer';
import * as fromIfaSearchProducts from './reducers/ifa-search-products.reducer';
import * as fromBeneficiaries from './reducers/beneficiaries.reducer';
import * as fromArchivedHomeAddress from './reducers/archived-home-address.reducer';
import * as fromArchivedProofGovId from './reducers/archived-proof-gov-id.reducer';
import * as fromArchivedSelfie from './reducers/archived-selfie.reducer';
import * as fromIfaSelectProductType from './reducers/ifa-select-product-type.reducer';
import * as fromNote from './reducers/note.reducer';
import * as fromMonthlyIncome from './reducers/monthly-income.reducer';
import * as fromLegalDocumentsCurrentReducer from './reducers/legal-documents-current.reducer';
import * as fromLegalDocumentsPreviousReducer from './reducers/legal-documents-previous.reducer';
import * as fromCurrentProductsForSomeoneElse from './reducers/current-products-for-someone-else.reducer';
import * as fromPastProductsForSomeoneElse from './reducers/past-products-for-someone-else.reducer';
import * as fromUpcomingProductsForSomeoneElse from './reducers/upcoming-products-for-someone-else.reducer';
import * as fromPendingProductsForSomeoneElse from './reducers/pending-products-for-someone-else.reducer';
import * as fromCurrentProductsFromSomeoneElse from './reducers/current-products-from-someone-else.reducer';
import * as fromPastProductsFromSomeoneElse from './reducers/past-products-from-someone-else.reducer';
import * as fromUpcomingProductsFromSomeoneElse from './reducers/upcoming-products-from-someone-else.reducer';
import * as fromPendingProductsFromSomeoneElse from './reducers/pending-products-from-someone-else.reducer';
import * as fromUpdateMobileNumberReducer from './reducers/update-mobile-number.reducer';
import * as fromResignEmployeeReducer from './reducers/resign-employee.reducer';
import * as fromGroupedProducts from './reducers/grouped-products.reducer';
import * as fromGroupedProductsForSomeoneElse from './reducers/grouped-products-for-someone-else.reducer';
import * as fromGroupedProductsFromSomeoneElse from './reducers/grouped-products-from-someone-else.reducer';
import * as fromEmployeeBusinessesReducer from './reducers/employee-businesses.reducer';
import * as fromEmployeeWithdrawalsReducer from './reducers/employee-withdrawals.reducer';
import * as fromEmployeeWithdrawalMarkAsRequestedReducer from './reducers/employee-withdrawal-mark-as-requested.reducer';
import * as fromBankProofReducer from './reducers/bank-proof.reducer';
import * as fromApproveBankProofReducer from './reducers/approve-bankproof.reducer';
import * as fromRejectBankProofReducer from './reducers/reject-bankproof.reducer';
import * as fromDownloadPlaybackDocumentReducer from './reducers/download-playback-document.reducer';
import * as fromBotflowPlayback from './reducers/botflow-playback.reducer';
import * as fromBankDetailsReducer from './reducers/bank-details.reducer';
import * as fromProfileStatusReducer from './reducers/profile-status.reducer';
import * as fromBankProofDocumentReducer from './reducers/bankproof-documents.reducer';
import * as fromUpdateBank from './reducers/update-bank.reducer';
import * as fromRemoveBank from './reducers/remove-bank.reducer';
import * as fromFilteredTransactionsReducer from './reducers/filtered-transactions.reducer';
import * as fromDeleteCustomerReducer from './reducers/delete-customer.reducer';
import * as fromRestoreCustomerReducer from './reducers/restore-customer.reducer';
import * as fromEmployeeRiskProductsReducer from './reducers/employee-risk-products.reducer';

export const employeeDetailFeatureKey = 'employeeDetailMain';

//REGISTER STATE

export interface EmployeeDetailMainState {
  [fromEmployeeDetailReducer.employeeDetailFeatureKey]: fromEmployeeDetailReducer.EmployeeDetailState;
  [fromDeceasedReducer.deceasedFeatureKey]: fromDeceasedReducer.DeceasedState;
  [fromUpdateDeceasedReducer.updateDeceasedReducerFeatureKey]: fromUpdateDeceasedReducer.UpdateDeceasedState;
  [fromBlockReducer.userBlockedFeatureKey]: fromBlockReducer.UserBlockedState;
  [fromCheckBlockReducer.checkUserBlockedFeatureKey]: fromCheckBlockReducer.CheckUserBlockedState;
  [fromCheckLockReducer.checkUserLockedFeatureKey]: fromCheckLockReducer.CheckLockedState;
  [fromLockReducer.lockFeatureKey]: fromLockReducer.LockState;
  [fromRemoveReducer.removeUserFeatureKey]: fromRemoveReducer.RemovedState;
  [fromCheckRemoveReducer.checkUserRemovedFeatureKey]: fromCheckRemoveReducer.CheckUserRemovedState;
  [fromUserRoleReducer.userRoleFeatureKey]: fromUserRoleReducer.UserRoleState;
  [fromGovIdReducer.governmentIdFeatureKey]: fromGovIdReducer.GovernmentIdState;
  [fromSelfieReducer.selfieFeatureKey]: fromSelfieReducer.CurrentSelfieState;
  [fromPreviousSelfieReducer.previousSelfieFeatureKey]: fromPreviousSelfieReducer.PreviousSelfieState;
  [fromApproveReducer.approveDocumentsFeatureKey]: fromApproveReducer.ApproveDocumentsState;
  [fromUnLockReducer.unlockFeatureKey]: fromUnLockReducer.UnLockState;
  [fromUnBLockReducer.userUnblockedFeatureKey]: fromUnBLockReducer.UserUnBlockedState;
  [fromALIVEReducer.aliveFeatureKey]: fromALIVEReducer.AliveState;
  [fromRejectReducer.rejectDocumentFeatureKey]: fromRejectReducer.RejectDocumentsState;
  [fromHomeAddressReducer.homeAddressCurrentFeatureKey]: fromHomeAddressReducer.HomeAddressState;
  [fromPrivacySettingsReducer.privacySettingsFeatureKey]: fromPrivacySettingsReducer.PrivacySettingsState;
  [fromToDoReducer.toDosFeatureKey]: fromToDoReducer.ToDosState;
  [fromSendTaxReducerReducer.sendTaxCertFeatureKey]: fromSendTaxReducerReducer.sendTaxCertState;
  [fromTaxYearsReducer.taxYearsFeatureKey]: fromTaxYearsReducer.TaxYearsState;
  [fromGovIdProofReducer.govIdProofFeatureKey]: fromGovIdProofReducer.GovIdProofState;
  [fromOpenFileReducer.openFileFeatureKey]: fromOpenFileReducer.openFileState;
  [fromCurrentProducts.currentProductsFeatureKey]: fromCurrentProducts.CurrentProductsState;
  [fromArchivedProducts.archivedProductsFeatureKey]: fromArchivedProducts.ArchivedProductsState;
  [fromNotifications.notificationsFeatureKey]: fromNotifications.NotificationState;
  [fromBiDetails.biDetailsFeatureKey]: fromBiDetails.BusinessInfoDetialsState;
  [fromBiRemoveDetails.biRemoveEmployeeFeatureKey]: fromBiRemoveDetails.BusinessInfoRemoveEmployeeState;
  [fromBiUpdateBusinessDetails.biUpdateBusinessDetailsFeatureKey]: fromBiUpdateBusinessDetails.UpdateBusinessDetailsState;
  // [fromIfaRepKnowledge.ifaRepKnowledgeFeatureKey]: fromIfaRepKnowledge.IFARepKnowledgeState;
  [fromIfaSearchProducts.ifaSearchProductsFeatureKey]: fromIfaSearchProducts.IfaSearchProductsState;
  // [fromIfaAddProduct.ifaAddProductFeatureKey]: fromIfaAddProduct.IfaAddProductState;
  [fromBeneficiaries.beneficiariesFeatureKey]: fromBeneficiaries.BeneficiariesState;
  [fromArchivedHomeAddress.archivedHomeAddressFeatureKey]: fromArchivedHomeAddress.ArchivedHomeAddressState;
  [fromArchivedProofGovId.archivedProofGovIdFeatureKey]: fromArchivedProofGovId.ArchivedProofGovIdState;
  [fromArchivedSelfie.archivedSelfieFeatureKey]: fromArchivedSelfie.ArchivedSelfieState;
  [fromIfaSelectProductType.ifaSelectProductTypeFeatureKey]: fromIfaSelectProductType.IfaSelectProductTypeState;
  [fromNote.noteFeatureKey]: fromNote.NoteState;
  [fromRetirementPlanReducer.retirementPlanFeatureKey]: fromRetirementPlanReducer.RetirementPlanState;
  [fromMonthlyIncome.monthlyIncomeFeatureKey]: fromMonthlyIncome.MonthlyIncomeState;
  [fromLegalDocumentsCurrentReducer.currentLegalDocumentsFeatureKey]: fromLegalDocumentsCurrentReducer.CurrentLegalDocumentsState;
  [fromLegalDocumentsPreviousReducer.previousLegalDocumentsFeatureKey]: fromLegalDocumentsPreviousReducer.PreviousLegalDocumentsState;
  [fromFNA.FNAFeatureKey]: fromFNA.FNAState;
  [fromStatements.statementsFeatureKey]: fromStatements.State;
  [fromPreviousStatements.previousStatementsFeatureKey]: fromPreviousStatements.State;
  [fromTransactionsAll.transactionsAllFeatureKey]: fromTransactionsAll.TransactionsAllState;
  [fromCurrentProductsForSomeoneElse.currentProductsForSomeoneElseFeatureKey]: fromCurrentProductsForSomeoneElse.CurrentProductsForSomeoneElseState;
  [fromPastProductsForSomeoneElse.pastProductsForSomeoneElseFeatureKey]: fromPastProductsForSomeoneElse.PastProductsForSomeoneElseState;
  [fromUpcomingProductsForSomeoneElse.upcomingProductsForSomeoneElseFeatureKey]: fromUpcomingProductsForSomeoneElse.UpcomingProductsForSomeoneElseState;
  [fromPendingProductsForSomeoneElse.pendingProductsForSomeoneElseFeatureKey]: fromPendingProductsForSomeoneElse.PendingProductsForSomeoneElseState;
  [fromCurrentProductsFromSomeoneElse.currentProductsFromSomeoneElseFeatureKey]: fromCurrentProductsFromSomeoneElse.CurrentProductsFromSomeoneElseState;
  [fromPastProductsFromSomeoneElse.pastProductsFromSomeoneElseFeatureKey]: fromPastProductsFromSomeoneElse.PastProductsFromSomeoneElseState;
  [fromUpcomingProductsFromSomeoneElse.upcomingProductsFromSomeoneElseFeatureKey]: fromUpcomingProductsFromSomeoneElse.UpcomingProductsFromSomeoneElseState;
  [fromPendingProductsFromSomeoneElse.pendingProductsFromSomeoneElseFeatureKey]: fromPendingProductsFromSomeoneElse.PendingProductsFromSomeoneElseState;
  [fromUpdateMobileNumberReducer.updateMobileNumberFeatureKey]: fromUpdateMobileNumberReducer.UpdateMobileNumberState;
  [fromResignEmployeeReducer.resignEmployeeFeatureKey]: fromResignEmployeeReducer.ResignEmployeeState;
  [fromGenerateOtpReducer.generateOtpKey]: fromGenerateOtpReducer.GenerateOtpState;
  [fromGroupedProducts.groupedProductsFeatureKey]: fromGroupedProducts.GroupedProductsState;
  [fromGroupedProductsForSomeoneElse.groupedProductsForSomeoneElseFeatureKey]: fromGroupedProductsForSomeoneElse.GroupedProductsForSomeoneElseState;
  [fromGroupedProductsFromSomeoneElse.groupedProductsFromSomeoneElseFeatureKey]: fromGroupedProductsFromSomeoneElse.GroupedProductsFromSomeoneElseState;
  [fromEmployeeBusinessesReducer.employeeBusinessesKey]: fromEmployeeBusinessesReducer.EmployeeBusinessesState;
  [fromEmployeeWithdrawalsReducer.employeeWithdrawalsKey]: fromEmployeeWithdrawalsReducer.EmployeeWithdrawalsState;
  [fromEmployeeWithdrawalMarkAsRequestedReducer.markAsRequestedKey]: fromEmployeeWithdrawalMarkAsRequestedReducer.EmployeeWithdrawalMarkAsRequestedState;
  [fromBankProofReducer.bankProofFeatureKey]: fromBankProofReducer.CurrentBankProofState;
  [fromApproveBankProofReducer.approveBankProofFeatureKey]: fromApproveBankProofReducer.ApproveBankProofState;
  [fromRejectBankProofReducer.rejectBankProofFeatureKey]: fromRejectBankProofReducer.RejectBankProofState;
  [fromDownloadPlaybackDocumentReducer.downloadPlaybackDocumentFeatureKey]: fromDownloadPlaybackDocumentReducer.DownloadPlaybackDocumentState;
  [fromBotflowPlayback.botflowPlaybackFeatureKey]: fromBotflowPlayback.BotflowPlaybackState;
  [fromBankDetailsReducer.bankListFeatureKey]: fromBankDetailsReducer.BankListState;
  [fromProfileStatusReducer.profileStatusFeatureKey]: fromProfileStatusReducer.ProfileStatusState;
  [fromBankProofDocumentsReducer.bankProofDocumentsFeatureKey]: fromBankProofDocumentsReducer.CurrentBankProofDocumentsState;
  [fromArchivedBankProofDocumentsReducer.archivedBankProofDocumentsFeatureKey]: fromArchivedBankProofDocumentsReducer.ArchivedBankProofDocumentsState;
  [fromApproveBankProofDocumentReducer.approveBankProofDocumentFeatureKey]: fromApproveBankProofDocumentReducer.ApproveBankProofDocumentState;
  [fromRejectBankProofDocumentReducer.rejectBankProofDocumentFeatureKey]: fromRejectBankProofDocumentReducer.RejectBankProofDocumentState;
  //[fromAddBank.addBankFeatureKey]: fromAddBank.AddBankState;
  [fromUpdateBank.updateBankFeatureKey]: fromUpdateBank.UpdateBankState;
  [fromRemoveBank.removeBankFeatureKey]: fromRemoveBank.RemoveBankState;
  [fromAddBankReducer.addBankFeatureKey]: fromAddBankReducer.AddBankState;
  [fromFilteredTransactions.filteredTransactionsFeatureKey]: fromFilteredTransactions.FilteredTransactionsState;
  [fromUpdateMemberDetailReducer.updateMemberDetailFeatureKey]: fromUpdateMemberDetailReducer.UpdateMemberDetailState;
  [fromComplianceReducer.complianceFeatureKey]: fromComplianceReducer.ComplianceState;
  [fromAddCharityBeneficiaryReducer.addCharityBeneficiaryFeatureKey]: fromAddCharityBeneficiaryReducer.AddCharityBeneficiaryState;
  [fromAddIndividualBeneficiaryReducer.addIndividualBeneficiaryFeatureKey]: fromAddIndividualBeneficiaryReducer.AddIndividualBeneficiaryState;
  [fromAddTrustBeneficiaryReducer.addTrustBeneficiaryFeatureKey]: fromAddTrustBeneficiaryReducer.AddTrustBeneficiaryState;
  [fromEmployeeGovtIdDetailsReducer.employeeGovtIdDetailsKey]: fromEmployeeGovtIdDetailsReducer.EmployeeGovtIdDetailsState;
  [fromEmployeeHomeAddressReducer.employeeHomeAddressFeatureKey]: fromEmployeeHomeAddressReducer.EmployeeHomeAddressState;
  [fromDeleteCustomerReducer.deleteCustomerFeatureKey]: fromDeleteCustomerReducer.DeleteCustomerState;
  [fromRestoreCustomerReducer.restoreCustomerFeatureKey]: fromRestoreCustomerReducer.RestoreCustomerState;
  [fromEmployeeRiskProductsReducer.employeeRiskProductsFeatureKey]: fromEmployeeRiskProductsReducer.EmployeeRiskProductsState;
}

export interface State {
  [employeeDetailFeatureKey]: EmployeeDetailMainState;
}

export function reducers(state: EmployeeDetailMainState | undefined, action: Action) {
  return combineReducers({
    [fromEmployeeDetailReducer.employeeDetailFeatureKey]: fromEmployeeDetailReducer.reducer,
    [fromDeceasedReducer.deceasedFeatureKey]: fromDeceasedReducer.reducer,
    [fromUpdateDeceasedReducer.updateDeceasedReducerFeatureKey]: fromUpdateDeceasedReducer.reducer,
    [fromBlockReducer.userBlockedFeatureKey]: fromBlockReducer.reducer,
    [fromCheckBlockReducer.checkUserBlockedFeatureKey]: fromCheckBlockReducer.reducer,
    [fromCheckLockReducer.checkUserLockedFeatureKey]: fromCheckLockReducer.reducer,
    [fromLockReducer.lockFeatureKey]: fromLockReducer.reducer,
    [fromRemoveReducer.removeUserFeatureKey]: fromRemoveReducer.reducer,
    [fromCheckRemoveReducer.checkUserRemovedFeatureKey]: fromCheckRemoveReducer.reducer,
    [fromUserRoleReducer.userRoleFeatureKey]: fromUserRoleReducer.reducer,
    [fromGovIdReducer.governmentIdFeatureKey]: fromGovIdReducer.reducer,
    [fromSelfieReducer.selfieFeatureKey]: fromSelfieReducer.reducer,
    [fromPreviousSelfieReducer.previousSelfieFeatureKey]: fromPreviousSelfieReducer.reducer,
    [fromApproveReducer.approveDocumentsFeatureKey]: fromApproveReducer.reducer,
    [fromUnLockReducer.unlockFeatureKey]: fromUnLockReducer.reducer,
    [fromUnBLockReducer.userUnblockedFeatureKey]: fromUnBLockReducer.reducer,
    [fromALIVEReducer.aliveFeatureKey]: fromALIVEReducer.reducer,
    [fromRejectReducer.rejectDocumentFeatureKey]: fromRejectReducer.reducer,
    [fromHomeAddressReducer.homeAddressCurrentFeatureKey]: fromHomeAddressReducer.reducer,
    [fromPrivacySettingsReducer.privacySettingsFeatureKey]: fromPrivacySettingsReducer.reducer,
    [fromToDoReducer.toDosFeatureKey]: fromToDoReducer.reducer,
    [fromSendTaxReducerReducer.sendTaxCertFeatureKey]: fromSendTaxReducerReducer.reducer,
    [fromTaxYearsReducer.taxYearsFeatureKey]: fromTaxYearsReducer.reducer,
    [fromGovIdProofReducer.govIdProofFeatureKey]: fromGovIdProofReducer.reducer,
    [fromOpenFileReducer.openFileFeatureKey]: fromOpenFileReducer.reducer,
    [fromCurrentProducts.currentProductsFeatureKey]: fromCurrentProducts.reducer,
    [fromArchivedProducts.archivedProductsFeatureKey]: fromArchivedProducts.reducer,
    [fromNotifications.notificationsFeatureKey]: fromNotifications.reducer,
    [fromBiDetails.biDetailsFeatureKey]: fromBiDetails.reducer,
    [fromBiRemoveDetails.biRemoveEmployeeFeatureKey]: fromBiRemoveDetails.reducer,
    [fromBiUpdateBusinessDetails.biUpdateBusinessDetailsFeatureKey]: fromBiUpdateBusinessDetails.reducer,
    // [fromIfaRepKnowledge.ifaRepKnowledgeFeatureKey]: fromIfaRepKnowledge.reducer,
    [fromIfaSearchProducts.ifaSearchProductsFeatureKey]: fromIfaSearchProducts.reducer,
    // [fromIfaAddProduct.ifaAddProductFeatureKey]: fromIfaAddProduct.reducer,
    [fromBeneficiaries.beneficiariesFeatureKey]: fromBeneficiaries.reducer,
    [fromArchivedHomeAddress.archivedHomeAddressFeatureKey]: fromArchivedHomeAddress.reducer,
    [fromArchivedProofGovId.archivedProofGovIdFeatureKey]: fromArchivedProofGovId.reducer,
    [fromArchivedSelfie.archivedSelfieFeatureKey]: fromArchivedSelfie.reducer,
    [fromIfaSelectProductType.ifaSelectProductTypeFeatureKey]: fromIfaSelectProductType.reducer,
    [fromNote.noteFeatureKey]: fromNote.reducer,
    [fromRetirementPlanReducer.retirementPlanFeatureKey]: fromRetirementPlanReducer.reducer,
    [fromGroupedProducts.groupedProductsFeatureKey]: fromGroupedProducts.reducer,
    [fromGroupedProductsForSomeoneElse.groupedProductsForSomeoneElseFeatureKey]: fromGroupedProductsForSomeoneElse.reducer,
    [fromGroupedProductsFromSomeoneElse.groupedProductsFromSomeoneElseFeatureKey]: fromGroupedProductsFromSomeoneElse.reducer,
    [fromMonthlyIncome.monthlyIncomeFeatureKey]: fromMonthlyIncome.reducer,
    [fromLegalDocumentsCurrentReducer.currentLegalDocumentsFeatureKey]: fromLegalDocumentsCurrentReducer.reducer,
    [fromLegalDocumentsPreviousReducer.previousLegalDocumentsFeatureKey]: fromLegalDocumentsPreviousReducer.reducer,
    [fromFNA.FNAFeatureKey]: fromFNA.reducer,
    [fromStatements.statementsFeatureKey]: fromStatements.reducer,
    [fromPreviousStatements.previousStatementsFeatureKey]: fromPreviousStatements.reducer,
    [fromTransactionsAll.transactionsAllFeatureKey]: fromTransactionsAll.reducer,
    [fromCurrentProductsForSomeoneElse.currentProductsForSomeoneElseFeatureKey]: fromCurrentProductsForSomeoneElse.reducer,
    [fromPastProductsForSomeoneElse.pastProductsForSomeoneElseFeatureKey]: fromPastProductsForSomeoneElse.reducer,
    [fromUpcomingProductsForSomeoneElse.upcomingProductsForSomeoneElseFeatureKey]: fromUpcomingProductsForSomeoneElse.reducer,
    [fromPendingProductsForSomeoneElse.pendingProductsForSomeoneElseFeatureKey]: fromPendingProductsForSomeoneElse.reducer,
    [fromCurrentProductsFromSomeoneElse.currentProductsFromSomeoneElseFeatureKey]: fromCurrentProductsFromSomeoneElse.reducer,
    [fromPastProductsFromSomeoneElse.pastProductsFromSomeoneElseFeatureKey]: fromPastProductsFromSomeoneElse.reducer,
    [fromUpcomingProductsFromSomeoneElse.upcomingProductsFromSomeoneElseFeatureKey]: fromUpcomingProductsFromSomeoneElse.reducer,
    [fromPendingProductsFromSomeoneElse.pendingProductsFromSomeoneElseFeatureKey]: fromPendingProductsFromSomeoneElse.reducer,
    [fromUpdateMobileNumberReducer.updateMobileNumberFeatureKey]: fromUpdateMobileNumberReducer.reducer,
    [fromResignEmployeeReducer.resignEmployeeFeatureKey]: fromResignEmployeeReducer.reducer,
    [fromGenerateOtpReducer.generateOtpKey]: fromGenerateOtpReducer.reducer,
    [fromEmployeeBusinessesReducer.employeeBusinessesKey]: fromEmployeeBusinessesReducer.reducer,
    [fromEmployeeWithdrawalsReducer.employeeWithdrawalsKey]: fromEmployeeWithdrawalsReducer.reducer,
    [fromEmployeeWithdrawalMarkAsRequestedReducer.markAsRequestedKey]: fromEmployeeWithdrawalMarkAsRequestedReducer.reducer,
    [fromBankProofReducer.bankProofFeatureKey]: fromBankProofReducer.reducer,
    [fromApproveBankProofReducer.approveBankProofFeatureKey]: fromApproveBankProofReducer.reducer,
    [fromRejectBankProofReducer.rejectBankProofFeatureKey]: fromRejectBankProofReducer.reducer,
    [fromDownloadPlaybackDocumentReducer.downloadPlaybackDocumentFeatureKey]: fromDownloadPlaybackDocumentReducer.reducer,
    [fromBotflowPlayback.botflowPlaybackFeatureKey]: fromBotflowPlayback.reducer,
    [fromBankDetailsReducer.bankListFeatureKey]: fromBankDetailsReducer.reducer,
    [fromBankProofDocumentsReducer.bankProofDocumentsFeatureKey]: fromBankProofDocumentsReducer.reducer,
    [fromArchivedBankProofDocumentsReducer.archivedBankProofDocumentsFeatureKey]: fromArchivedBankProofDocumentsReducer.reducer,
    [fromApproveBankProofDocumentReducer.approveBankProofDocumentFeatureKey]: fromApproveBankProofDocumentReducer.reducer,
    [fromRejectBankProofDocumentReducer.rejectBankProofDocumentFeatureKey]: fromRejectBankProofDocumentReducer.reducer,
    //[fromAddBank.addBankFeatureKey]: fromAddBank.reducer,
    [fromUpdateBank.updateBankFeatureKey]: fromUpdateBank.reducer,
    [fromRemoveBank.removeBankFeatureKey]: fromRemoveBank.reducer,
    [fromAddBankReducer.addBankFeatureKey]: fromAddBankReducer.reducer,
    [fromFilteredTransactions.filteredTransactionsFeatureKey]: fromFilteredTransactions.reducer,
    [fromProfileStatusReducer.profileStatusFeatureKey]: fromProfileStatusReducer.reducer,
    [fromUpdateMemberDetailReducer.updateMemberDetailFeatureKey]: fromUpdateMemberDetailReducer.reducer,
    [fromComplianceReducer.complianceFeatureKey]: fromComplianceReducer.reducer,
    [fromAddCharityBeneficiaryReducer.addCharityBeneficiaryFeatureKey]: fromAddCharityBeneficiaryReducer.reducer,
    [fromAddIndividualBeneficiaryReducer.addIndividualBeneficiaryFeatureKey]: fromAddIndividualBeneficiaryReducer.reducer,
    [fromAddTrustBeneficiaryReducer.addTrustBeneficiaryFeatureKey]: fromAddTrustBeneficiaryReducer.reducer,
    [fromEmployeeGovtIdDetailsReducer.employeeGovtIdDetailsKey]: fromEmployeeGovtIdDetailsReducer.reducer,
    [fromEmployeeHomeAddressReducer.employeeHomeAddressFeatureKey]: fromEmployeeHomeAddressReducer.reducer,
    [fromDeleteCustomerReducer.deleteCustomerFeatureKey]: fromDeleteCustomerReducer.reducer,
    [fromRestoreCustomerReducer.restoreCustomerFeatureKey]: fromRestoreCustomerReducer.reducer,
    [fromEmployeeRiskProductsReducer.employeeRiskProductsFeatureKey]: fromEmployeeRiskProductsReducer.reducer
  })(state, action);
}

//#region SELECT STATES
export const getRootState = createFeatureSelector<State, EmployeeDetailMainState>(employeeDetailFeatureKey);

export const getCurrentProductsState = createSelector(getRootState, state => state[fromCurrentProducts.currentProductsFeatureKey]);

export const getArchivedProductsState = createSelector(getRootState, state => state[fromArchivedProducts.archivedProductsFeatureKey]);

export const getNotificationState = createSelector(getRootState, state => state[fromNotifications.notificationsFeatureKey]);

export const getBusinessInfoDetailsState = createSelector(getRootState, state => state[fromBiDetails.biDetailsFeatureKey]);

export const getBusinessInfoRemoveEmployeeState = createSelector(
  getRootState,
  state => state[fromBiRemoveDetails.biRemoveEmployeeFeatureKey]
);


export const getSelectIFAProductTypeState = createSelector(
  getRootState,
  state => state[fromIfaSelectProductType.ifaSelectProductTypeFeatureKey]
);

export const getIFASearchProductsState = createSelector(getRootState, state => state[fromIfaSearchProducts.ifaSearchProductsFeatureKey]);

export const getBeneficiariesState = createSelector(getRootState, state => state[fromBeneficiaries.beneficiariesFeatureKey]);

export const getArchivedHomeAddressState = createSelector(
  getRootState,
  state => state[fromArchivedHomeAddress.archivedHomeAddressFeatureKey]
);

export const getArchivedProofGovIdsState = createSelector(
  getRootState,
  state => state[fromArchivedProofGovId.archivedProofGovIdFeatureKey]
);

export const getArchivedSelfiesState = createSelector(getRootState, state => state[fromArchivedSelfie.archivedSelfieFeatureKey]);

export const getNoteState = createSelector(getRootState, state => state[fromNote.noteFeatureKey]);

export const getRetirementPlanState = createSelector(getRootState, state => state[fromRetirementPlanReducer.retirementPlanFeatureKey]);
export const getMonthlyIncomeState = createSelector(getRootState, state => state[fromMonthlyIncome.monthlyIncomeFeatureKey]);
export const getCurrentLegalDocumentsState = createSelector(
  getRootState,
  state => state[fromLegalDocumentsCurrentReducer.currentLegalDocumentsFeatureKey]
);
export const getPreviousLegalDocumentsState = createSelector(
  getRootState,
  state => state[fromLegalDocumentsPreviousReducer.previousLegalDocumentsFeatureKey]
);
export const getFNAState = createSelector(getRootState, state => state[fromFNA.FNAFeatureKey]);
export const getStatementsState = createSelector(getRootState, state => state[fromStatements.statementsFeatureKey]);
export const getPreviousStatementsState = createSelector(getRootState, state => state[fromPreviousStatements.previousStatementsFeatureKey]);
export const transactionsAllState = createSelector(getRootState, state => state[fromTransactionsAll.transactionsAllFeatureKey]);

export const getCurrentProductsForSomeoneElseState = createSelector(
  getRootState,
  state => state[fromCurrentProductsForSomeoneElse.currentProductsForSomeoneElseFeatureKey]
);
export const getPastProductsForSomeoneElseState = createSelector(
  getRootState,
  state => state[fromPastProductsForSomeoneElse.pastProductsForSomeoneElseFeatureKey]
);
export const getUpcomingProductsForSomeoneElseState = createSelector(
  getRootState,
  state => state[fromUpcomingProductsForSomeoneElse.upcomingProductsForSomeoneElseFeatureKey]
);
export const getPendingProductsForSomeoneElseState = createSelector(
  getRootState,
  state => state[fromPendingProductsForSomeoneElse.pendingProductsForSomeoneElseFeatureKey]
);

export const getCurrentProductsFromSomeoneElseState = createSelector(
  getRootState,
  state => state[fromCurrentProductsFromSomeoneElse.currentProductsFromSomeoneElseFeatureKey]
);
export const getPastProductsFromSomeoneElseState = createSelector(
  getRootState,
  state => state[fromPastProductsFromSomeoneElse.pastProductsFromSomeoneElseFeatureKey]
);
export const getUpcomingProductsFromSomeoneElseState = createSelector(
  getRootState,
  state => state[fromUpcomingProductsFromSomeoneElse.upcomingProductsFromSomeoneElseFeatureKey]
);
export const getPendingProductsFromSomeoneElseState = createSelector(
  getRootState,
  state => state[fromPendingProductsFromSomeoneElse.pendingProductsFromSomeoneElseFeatureKey]
);
export const getUpdateMobileNumberState = createSelector(
  getRootState,
  state => state[fromUpdateMobileNumberReducer.updateMobileNumberFeatureKey]
);
export const getUpdateMemberDetailState = createSelector(getRootState, state => state[fromUpdateMemberDetailReducer.updateMemberDetailFeatureKey]);
export const getComplianceState = createSelector(getRootState, state => state[fromComplianceReducer.complianceFeatureKey]);
export const getResignEmployeeState = createSelector(getRootState, state => state[fromResignEmployeeReducer.resignEmployeeFeatureKey]);
export const getGenerateOtpState = createSelector(getRootState, state => state[fromGenerateOtpReducer.generateOtpKey]);
export const getGroupedProductsState = createSelector(getRootState, state => state[fromGroupedProducts.groupedProductsFeatureKey]);
export const getGroupedProductsForSomeoneElseState = createSelector(
  getRootState,
  state => state[fromGroupedProductsForSomeoneElse.groupedProductsForSomeoneElseFeatureKey]
);
export const getGroupedProductsFromSomeoneElseState = createSelector(
  getRootState,
  state => state[fromGroupedProductsFromSomeoneElse.groupedProductsFromSomeoneElseFeatureKey]
);
export const getEmployeeBusinessesState = createSelector(getRootState, state => state[fromEmployeeBusinessesReducer.employeeBusinessesKey]);
export const getEmployeeWithdrawalsState = createSelector(
  getRootState,
  state => state[fromEmployeeWithdrawalsReducer.employeeWithdrawalsKey]
);
export const getEmployeeWithdrawalMarkAsRequestedState = createSelector(
  getRootState,
  state => state[fromEmployeeWithdrawalMarkAsRequestedReducer.markAsRequestedKey]
);
export const getBankProofsState = createSelector(getRootState, state => state[fromBankProofReducer.bankProofFeatureKey]);
export const approveBankProofState = createSelector(getRootState, state => state[fromApproveBankProofReducer.approveBankProofFeatureKey]);
export const rejectBankProofState = createSelector(getRootState, state => state[fromRejectBankProofReducer.rejectBankProofFeatureKey]);
export const downloadPlaybackDocumentState = createSelector(
  getRootState,
  state => state[fromDownloadPlaybackDocumentReducer.downloadPlaybackDocumentFeatureKey]
);
export const getBankListState = createSelector(getRootState, state => state[fromBankDetailsReducer.bankListFeatureKey]);
export const getProfileStatusState = createSelector(getRootState, state => state[fromProfileStatusReducer.profileStatusFeatureKey]);
export const getBankProofDocumentsState = createSelector(getRootState, state => state[fromBankProofDocumentsReducer.bankProofDocumentsFeatureKey]);
export const getArchivedBankProofDocumentsState = createSelector(getRootState, state => state[fromArchivedBankProofDocumentsReducer.archivedBankProofDocumentsFeatureKey]);
export const getApproveBankProofDocumentState = createSelector(getRootState, state => state[fromApproveBankProofDocumentReducer.approveBankProofDocumentFeatureKey]);
export const getRejectBankProofDocumentState = createSelector(getRootState, state => state[fromRejectBankProofDocumentReducer.rejectBankProofDocumentFeatureKey]);
export const getAddBankState = createSelector(getRootState, state => state[fromAddBankReducer.addBankFeatureKey]);
export const getUpdateBankState = createSelector(getRootState, state => state[fromUpdateBank.updateBankFeatureKey]);
export const getRemoveBankState = createSelector(getRootState, state => state[fromRemoveBank.removeBankFeatureKey]);
export const getFilteredTransactionsState = createSelector(getRootState, state => state[fromFilteredTransactions.filteredTransactionsFeatureKey]);
export const getAddCharityBeneficiaryState = createSelector(getRootState, state => state[fromAddCharityBeneficiaryReducer.addCharityBeneficiaryFeatureKey]);
export const getAddIndividualBeneficiaryState = createSelector(getRootState, state => state[fromAddIndividualBeneficiaryReducer.addIndividualBeneficiaryFeatureKey]);
export const getAddTrustBeneficiaryState = createSelector(getRootState, state => state[fromAddTrustBeneficiaryReducer.addTrustBeneficiaryFeatureKey]);
export const getEmployeeGovtIdDetailsState = createSelector(getRootState, state => state[fromEmployeeGovtIdDetailsReducer.employeeGovtIdDetailsKey]);
export const getEmployeeHomeAddressState = createSelector(getRootState, state => state[fromEmployeeHomeAddressReducer.employeeHomeAddressFeatureKey]);
export const getDeleteCustomerState = createSelector(getRootState, state => state[fromDeleteCustomerReducer.deleteCustomerFeatureKey]);
export const getRestoreCustomerState = createSelector(getRootState, state => state[fromRestoreCustomerReducer.restoreCustomerFeatureKey]);
//#endregion
